// Course cost (price per seat) MANUAL OVERRIDE map for revenue projections.
//
// WHY THIS FILE EXISTS
// --------------------
// The projected-revenue report pulls prices LIVE from Dataverse
// (`mi_course`, via scheduleGeneratorService.getCoursePrices). This file is
// only a fallback override: it fills in a price for any course that is missing
// one in the catalog, or is used entirely when Dataverse is unavailable.
// Normally it can stay empty.
//
// HOW TO MAINTAIN
// ---------------
// Add one entry per course, keyed by the exact course name shown in the draft
// schedule (case-insensitive match is applied). Value is the price for ONE
// seat, in whole dollars. Courses that end up with no price (neither here nor
// in mi_course) are reported on the Assumptions sheet so gaps are visible
// before approval.
//
// Example:
//   'Basic Firefighting': 1200,
//   'Advanced Marine Firefighting': 1500,

const COURSE_COSTS = {
  // 'Course Name': pricePerSeat,
};

/**
 * Look up the per-seat cost for a course by name (case-insensitive).
 * Returns null when no price is configured so callers can flag it.
 * @param {string} courseName
 * @param {Record<string, number>} [costs] optional override map (for tests)
 * @returns {number|null}
 */
export function getCourseCost(courseName, costs = COURSE_COSTS) {
  if (!courseName) return null;
  // Fast path: exact key.
  if (Object.prototype.hasOwnProperty.call(costs, courseName)) {
    return Number(costs[courseName]) || 0;
  }
  // Case-insensitive fallback.
  const wanted = String(courseName).trim().toLowerCase();
  for (const key of Object.keys(costs)) {
    if (key.trim().toLowerCase() === wanted) {
      return Number(costs[key]) || 0;
    }
  }
  return null;
}

export default COURSE_COSTS;
